import React from 'react';
import { useParams } from 'react-router-dom';
import { EyeIcon } from 'lucide-react';
import { Breadcrumbs } from '../components/layout/Breadcrumbs';
import { Card } from '../components/ui/Card';
import { LeadWorkspace } from '../components/queue/LeadWorkspace';
import { ActivityTimeline } from '../components/queue/ActivityTimeline';
import { useAppState } from '../contexts/AppState';
import { officers } from '../data/reporting';
import { requiredCallsFor } from '../utils/format';
export function LeadDetail() {
  const {
    leadId
  } = useParams();
  const {
    allLeads,
    publishedSources,
    publishedPriority
  } = useAppState();
  const lead = allLeads.find(l => l.id === leadId);
  if (!lead) {
    return <Card className="px-6 py-16 text-center text-sm text-ink-500" data-id="element-393" data-mp="1j9fy0kdax36h">Lead not found.</Card>;
  }
  const source = publishedSources.find(s => s.id === lead.sourceId);
  const enabledPriority = publishedPriority.filter(r => r.enabled);
  const rule = enabledPriority.find(r => r.id === lead.priorityRuleId);
  const owner = officers.find(o => o.id === lead.ownerId);
  return <div className="space-y-5" data-id="element-394" data-mp="2zj6q4sb0qnqy">
      <Breadcrumbs items={[{
      label: 'Management Dashboard',
      to: '/reporting'
    }, ...(owner ? [{
      label: owner.name,
      to: `/reporting/officer/${owner.id}`
    }] : []), ...(source && owner ? [{
      label: source.name,
      to: `/reporting/officer/${owner.id}/source/${source.id}`
    }] : []), {
      label: lead.name
    }]} data-id="element-395" data-mp="2zix054pz4gl9" />

      <div className="flex items-center gap-2 rounded-xl border border-ink-200 bg-white px-4 py-3 text-xs font-medium text-ink-600" data-id="element-396" data-mp="2btlw9edbu62w">
        <EyeIcon className="h-4 w-4 text-ink-400" aria-hidden="true" data-id="element-397" data-mp="26vk9ojgozomo" />
        Management inspection view — the same workspace the Loan Officer sees, read only.
      </div>

      <LeadWorkspace lead={lead} source={source} priorityIndex={enabledPriority.findIndex(r => r.id === lead.priorityRuleId) + 1} priorityLabel={rule?.label ?? 'Not currently queued'} priorityReason={rule?.summary ?? 'This lead does not match an active priority rule.'} requiredCalls={requiredCallsFor(source, lead.ageMinutes)} ownerName={owner?.name ?? 'Unassigned'} readOnly data-id="element-398" data-mp="1xu2v55ixnv03" />

      <ActivityTimeline activities={lead.activities} data-id="element-399" data-mp="1j7e13j7gaa13" />
    </div>;
}